import axios from 'axios'
import { host } from '../configuraciones'

//constantes
const dataInicial = {
    data: {},
    fc_05: {},
    loading: false,
    modoEdicionBorrador: false,
}

//types
const AGREGAR_FC_05_EXITO = 'AGREGAR_FC_05_EXITO'
const AGREGAR_ARCHIVOS_FC_05_EXITO = 'AGREGAR_FC_05_ARCHIVOS_EXITO'
const GUARDAR_CAMBIOS_FC_05_EXITO = 'GUARDAR_CAMBIOS_FC_05_EXITO'
const OBTENER_FC_05_GUARDADA_EXITO = 'OBTENER_FC_05_GUARDADA_EXITO'
const OBTENER_FC_05_DETALLE_EXITO = 'OBTENER_FC_05_DETALLE_EXITO'

const AGREGAR_FC_05_BORRADOR_EXITO = 'AGREGAR_FC_05_BORRADOR_EXITO'
const RESET_DATA_EXITO = 'RESET_DATA_EXITO'
const ACTUALIZAR_FC_05_ESTATUS_EXITO = 'ACTUALIZAR_FC_05_ESTATUS_EXITO'

const ELIMINAR_FC_05_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_05_SOLICITUD_EXITO_BD'

const ACTUALIZAR_MODO_EDICION_FC_05_EXITO = 'ACTUALIZAR_MODO_EDICION_FC_05_EXITO'
const GUARDAR_CAMBIOS_FC_05_BORRADOR_EXITO = 'GUARDAR_CAMBIOS_FC_05_BORRADOR_EXITO'
const AGREGAR_FC_05_EXITO_MAP = 'AGREGAR_FC_05_EXITO_MAP'
//reducer
export default function FC_05Reducer(state = dataInicial, action) {
    switch (action.type) {
        case AGREGAR_FC_05_EXITO:
            return { ...state }
        case AGREGAR_ARCHIVOS_FC_05_EXITO:
            return { ...state }
        case GUARDAR_CAMBIOS_FC_05_EXITO:
            {
                Object.assign(state.fc_05, action.payload);
                return {...state, fc_05: action.payload}
            }
        case OBTENER_FC_05_DETALLE_EXITO: {
            return { ...state, data: action.payload }
        }
        case AGREGAR_FC_05_BORRADOR_EXITO:
            return {...state}
        case ELIMINAR_FC_05_SOLICITUD_EXITO_BD:
            return {...state}
        case GUARDAR_CAMBIOS_FC_05_BORRADOR_EXITO:
            {
                Object.assign(state.data, action.payload);
                return {...state, data: action.payload}
            }
        case ACTUALIZAR_MODO_EDICION_FC_05_EXITO:
            {
                Object.assign(state.modoEdicionBorrador, action.payload);
                Object.assign(state.modoEdicionBorrador, {modoEdicionBorrador: action.payload})

                return {...state, modoEdicionBorrador: action.payload}
            }
        case RESET_DATA_EXITO :
            {
                let newDataObject = Object.assign(dataInicial, {
                    data: {},
                    fc_05: {},
                    loading: false,
                    modoEdicionBorrador: false
                })
                return newDataObject
            }
        case AGREGAR_FC_05_EXITO_MAP:
            return { ...state }
        default:
            return state
    }
}

//acciones
export const agregarFC_05Accion = (data) => async (dispatch) => {
    try {
        const solicitud = {data: data.solicitud}
        const archivos = data.archivos
        
        const agregarFC_05 = host + `FC_05/agregarFormatoFC05`
        const res = await axios.post(agregarFC_05, solicitud)
        
        let idfc05_solicitudusomarcaeimagen = res.data.data.idfc05_solicitudusomarcaeimagen
        //console.log("Data de FC_36 Archivos ", data.archivos)
        
        //console.log(idfc40_solicitudadquisicionholo)
       
        /*Archivos*/
        for(let i in archivos) {
            for(let item in archivos[i]){
                if(archivos[i][item]){
                    let formData = new FormData();
                    
                    formData.append((Number(i) + Number(1)), archivos[i][item])
                    formData.append('idSolicitud', idfc05_solicitudusomarcaeimagen)
                    //console.log(formData)
                    const resFile = await axios.post(host + 'FC_05/agregarNuevoFC_05AnexosArchivos', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                }
            }
        }
        dispatch({
            type: AGREGAR_FC_05_EXITO,
            payload: res.data.data
        })
        return res
    } catch (error) {
        console.log(error)
    }
}
export const agregarArchivoFC_05Accion = (data) => async (dispatch) => {
    try {
        const fullUrl = host + `FC_05/agregarNuevoFC_05AnexosArchivos`
        const res = await axios.post(fullUrl, { data })
        //console.log("la data es:", data)
        //console.log(res)
        dispatch({
            type: AGREGAR_ARCHIVOS_FC_05_EXITO,
            payload: res.data.data
        })
        return res
    } catch (error) {
        console.log(error)
    }
}
export const guardarCambiosFC_05Solicitud = (data) => async (dispatch) => {
    try {
        if(data.modoBorrador === true) {
            delete data.modoBorrador
            dispatch({
                type: GUARDAR_CAMBIOS_FC_05_BORRADOR_EXITO,
                payload: data
            })            
        }else {
            delete data.modoBorrador
            dispatch({
                type: GUARDAR_CAMBIOS_FC_05_EXITO,
                payload: data
            })
        }
    } catch (error) {
        console.log(error)
    }
}
export const obtenerFC_05Guardada = () => async (dispatch) => {
    try {
        dispatch({
            type: OBTENER_FC_05_GUARDADA_EXITO
        })
    } catch (error) {
        console.log(error)
    }
}
export const obtenerFC_05Detalle = (idfc05_solicitudusomarcaeimagen) => async (dispatch) => {
    try {
        const fullUrl = host + `FC_05/obtenerFormatoFC05_ConDetalle/${idfc05_solicitudusomarcaeimagen}`
        const res = await axios.get(fullUrl)
        console.log("el res devuelve?:", res.data.data)
        dispatch({
            type: OBTENER_FC_05_DETALLE_EXITO,
            payload: res.data.data
        })
        return res.data.data
    } catch (error) {
        console.log(error)
    }
}

/*Funcionalidad de borrador*/
export const agregarFC_05SolicitudBorrador = (data) => async (dispatch) => {
    try {
        //console.log('Data borrador FC_40: ', data)
        const fullUrl = host + `FC_05/agregarFormatoFC05`
        const res = await axios.post(fullUrl, {data})
        
        dispatch({
            type: AGREGAR_FC_05_BORRADOR_EXITO,
            payload: data
        })
        return res
    } catch (error) {
        console.log(error)
    }
}
export const actualizarFC_05SolicitudBorrador = (data) => async (dispatch) => {
    try {
        //console.log('data para actualizar fc_30: ', data)
        const solicitud = {data: data.solicitud}
        let archivos = null

        if(data.archivos){
            archivos = data.archivos
        }

        const agregarFC_05 = host + `FC_05/actualizarFormatoFC05`
        const res = await axios.put(agregarFC_05, solicitud)

        let idfc05_solicitudusomarcaeimagen = res.data.data.idfc05_solicitudusomarcaeimagen
        if(archivos !== null){
            
            //console.log(idfc40_solicitudadquisicionholo)
        
            /*Archivos*/
            for(let i in archivos) {
                for(let item in archivos[i]){
                    if(archivos[i][item]){
                        let formData = new FormData();
                        
                        formData.append((Number(i) + Number(1)), archivos[i][item])
                        formData.append('idSolicitud', idfc05_solicitudusomarcaeimagen)
                        //console.log(formData)
                        const resFile = await axios.post(host + 'FC_05/agregarNuevoFC_05AnexosArchivos', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                    }
                }
            }
        }

        dispatch({
            type: AGREGAR_FC_05_BORRADOR_EXITO,
            payload: data
        })
        return res
    } catch (error) {
        console.log(error)
    }
}
export const obtenerFC_05SolicitudDetalle = (idSolicitud) => async (dispatch) => {
    try {
        const fullUrl = host + `FC_05/obtenerFormatoFC05_ConDetalle/${idSolicitud}`
       
        const res = await axios.get(fullUrl)
        //console.log('URL: ', fullUrl)
        //console.log('res detalle: ', res)
        dispatch({
            type: OBTENER_FC_05_DETALLE_EXITO,
            payload: res.data.data
        })
    } catch (error) {
        console.log(error);
    }
}
export const resetDataFC_05 = () => (dispatch) => {
    try {
        dispatch({
            type: RESET_DATA_EXITO,
            payload: {
                data: {},
                fc_05: {},
                loading: false,
                modoEdicionBorrador: false
            }
        })
    } catch (error) {
        console.log(error);
    }
}

export const actualizarFC_05Estatus = (data) => async(dispatch) => {
    try {
        //console.log('data en actualizar estatus: ', data);
        const fullUrl = host + 'Estatus/actualizarEstatusTablas'
        const result = await axios.post(fullUrl, data)
        dispatch({
            type: ACTUALIZAR_FC_05_ESTATUS_EXITO
        })
    } catch (error) {
        console.log(error);
    }
}
export const eliminarFC_05SolicitudBD = (id) => async (dispatch) => {
    try {

        const fullUrlSolicitud = host + `FC_05/eliminarFormatoFC05/${id}`
        const resultDelete = await axios.delete(fullUrlSolicitud)
        dispatch({
            type: ELIMINAR_FC_05_SOLICITUD_EXITO_BD,
            payload: {id}
        })
    } catch (error) {
        console.log(error);
    }
}
export const actualizarModoBorradorFC_05 = (data) => (dispatch) => {
    try {
        dispatch({
            type: ACTUALIZAR_MODO_EDICION_FC_05_EXITO,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}
export const agregarMapFC_05Accion = (data) => async (dispatch) => {
    try {
        
        const agregarFC_05Map = host + `MapSolicitud/agregarMapFC_05_SolicitudParaAutorizacionUsoMarcaEImagenMap`
        const res = await axios.post(agregarFC_05Map,{data})
        dispatch({
            type: AGREGAR_FC_05_EXITO_MAP,
            payload: res.data.data
        })
        return res
    } catch (error) {
        console.log(error)
    }
}